
import React, { useEffect,useState } from 'react';
import { Layout, Breadcrumb,Row, Col, Button, Table, Tag, Drawer, Form, Select, Input, Space, message, Modal, Switch, DatePicker, Divider, Alert } from 'antd';
import { FormOutlined, DownloadOutlined, UploadOutlined,EyeOutlined,ExclamationCircleOutlined,SendOutlined } from '@ant-design/icons';
import './style.scss'
import { useNavigate } from "react-router-dom";
import Colors from '../../assets/themes/colors';
import GlobalSider from '../../components/GlobalSider';
import { addDataWithToken, appIdentifier, dateFormat, deleteDataWithToken, editDataWithToken, getDataWithToken, getLocal, globalUrlBare } from '../../globalFunctions/api';
import GlobalHeader from '../../components/GlobalHeader';
import moment from 'moment';
const {Content} = Layout;
const { Column, ColumnGroup } = Table;
const { Option } = Select;
const {confirm} = Modal

const pageTitle = 'ادارة البحوث المستلمة';

const  MngTeacherThesis = ()=> {
    const navigate = useNavigate();
    const [addInfoForm] = Form.useForm()
    const [editInfoForm] = Form.useForm()

    const [addInfoVisible, setAddInfoVisible] = useState(false);
    const [editInfoVisible, setEditInfoVisible] = useState(false);
    
    const [addLoading, setAddLoading] = useState(false);
    const [promiseLoading, setpromiseLoading] = useState(false);
    const [rateLoading, setrateLoading] = useState(false);
    const [selectedInfo, setSelectedInfo] = useState(null)
    const [infoFormInfo, setInfoFormInfo] = useState(null)
    const [infos, setInfos] = useState([]);
    const [totalCount, setTotalCount] = useState(null);
    const [certificates, setcertificates] = useState([])
    const [scintificTitles, setscintificTitles] = useState([])
    const localUserType = getLocal(appIdentifier)?.user?.user_type || null 

    const handleTableChange = (pagination, filters, sorter) => {
        const{current,pageSize} = pagination 
        getThesis(current,pageSize)
      };


      const onAddClose = () => {
        setAddInfoVisible(false);
        setSelectedInfo(null)
        addInfoForm.resetFields()
        
      };

      const onEditClose = () => {
        setEditInfoVisible(false);
        setSelectedInfo(null)
        editInfoForm.resetFields()
        
      };

   
   

      const getThesis = (current=1,pageSize=25)=>{
        setAddLoading(true)
        getDataWithToken(`dissertations?populate=deep,4&pagination[pageSize]=${pageSize}&pagination[page]=${current}`,
        (err,result)=>{
          setAddLoading(false);
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            setInfos(result?.data);
            setTotalCount(result?.meta?.total)
           }else{
            console.log(error)
             message?.error(error?.message)
           }
           
          }
        }) 
      }

      const getCertificates = (current=1,pageSize=25)=>{
        getDataWithToken(`certificates`,
        (err,result)=>{
         
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            setcertificates(result?.data);
           }else{
            console.log(error)
             message?.error(error?.message)
           }
          }
        }) 
      }

      const getScintificTitles = ()=>{
        getDataWithToken(`scintific-titles`,
        (err,result)=>{
         
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            setscintificTitles(result?.data);
           }else{
            console.log(error)
             message?.error(error?.message)
           }
          }
        }) 
      }

      const addInfo = (data)=>{
        setAddLoading(true)
        addDataWithToken(`infos`,data,
        (err,result)=>{
          setAddLoading(false);
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            message?.success('تم اضافة التدريسي بنجاح');
            getThesis();
            addInfoForm?.resetFields();
           }else{
            console.log(error)
             message?.error(error?.message)
           }
           
          }
        }) 
      }

      function showDeleteConfirm(A_field_name,id) {
        confirm({
            title: `  هل انت متأكد انك تريد حذف  ( ${A_field_name} )  `,
            icon: <ExclamationCircleOutlined style={{color:'red'}} />,
            content: 'ملاحظة : البيانات المحذوفة لا يمكن استعادتها لاحقا',
            okText: 'نعم',
            okType: 'danger',
            cancelText: 'الغاء',
            width:480,
            style:{textAlign:'right'},
            onOk() {
                setAddLoading(true);
                deleteDataWithToken(`infos/${id}`,(err, result)=>{

                    const {error} = result
                    if(err){
                        message?.error('خطأ في الشبكة')
                    }else{
                        if(!error){
                            message?.success('تم حذف التدريسي بنجاح');
                            getThesis();
                        }else{
                            console.log(error)
                            message?.error(error?.message)
                        }
                    
                    }
                })

            },
            onCancel() {
                console.log('Cancel');
            },
            });
        }   

        const prepareGetDetails = (data)=>{
            console.log(data)
            setSelectedInfo(data)
            addInfoForm.setFieldsValue({decision_status:data?.decision_status, decision_details:data?.decision_details})
            // const newData = {
            //     ...data,
            //     birthdate:moment(data?.birthdate),
            //     start_date:moment(data?.start_date),
            //     certificate:data?.certificate?.id,
            //     scintific_title:data?.scintific_title?.id
            // }
            // editInfoForm.setFieldsValue(newData)
            setAddInfoVisible(true)
        }

        const editInfo = (data)=>{
         
            setAddLoading(true);
            editDataWithToken(`infos/${selectedInfo?.id}`,data,(err, result)=>{
                const {error} = result
                if(err){
                    message?.error('خطأ في الشبكة')
                }else{
                    if(!error){
                        message?.success('تم تعديل التدريسي بنجاح');
                        getThesis();
                    }else{
                        console.log(error)
                        message?.error(error?.message)
                    }
                
                }
            })
          }


      useEffect(() => {
       getThesis();
       getCertificates();
       getScintificTitles();
      }, [])

      const returnCertTitle = (value)=>{
        var title = '';
        switch (value) {
            case 'master':
                title = 'الماجستير'
                break;

            case 'doctor':
                title = 'الدكتوراه'
                break;
            
        
            default:
                break;
        }
        return title
      }


      const returnStatusTitle = (value)=>{
        var title = '';
        switch (value) {
            case 'accepted_no_notes':
                title = <Tag color={'green'} >صالح للمناقشة بدون ملاحظات</Tag>
                break;

            case 'accepted_with_notes':
                title = <Tag color={'green'} >صالح للمناقشة - مع عرض الملاحظات المرفقة على لجنة المناقشة (حصراً)</Tag> 
                break;

            case 'rejected':
                title = <Tag color={'red'}  >لا تصلح للمناقشة - مع ذكر الاسباب المبررة الموجبة لرفض الرسالة / الاطروحة</Tag> 
                break;
            
        
            default:
                break;
        }
        return title
        
      }

      const [files,setFiles] = useState()
      const [promiseFiles,setpromiseFiles] = useState(null)
      const [rateFiles,setrateFiles] = useState()

      const uploadFile = async (e) => {
        const token = getLocal(appIdentifier)?.jwt ; 
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        var formdata = new FormData();
        formdata.append('files', files[0])
        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
        };
        fetch(`${globalUrlBare}/api/upload`, requestOptions)
        .then(response => response.json())
        .then(result => {
            addInfo({...e,stamped_promise_attachement:result?.[0]?.id})
            
            
        })
        .catch(error => console.log('error', error));
    }

    const uploadFileWithResult = async (fileContainer,successFunc) => {
        const token = getLocal(appIdentifier)?.jwt ; 
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        var formdata = new FormData();
        formdata.append('files', fileContainer)
        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
        };
        fetch(`${globalUrlBare}/api/upload`, requestOptions)
        .then(response => response.json())
        .then(result => {
          successFunc(result)
        })
        .catch(error => console.log('error', error));
    }


    const downloadFile = (filePath)=>{
        var link=document.createElement('a');
        link.href = filePath;
        link.target = '_blank'
        link.setAttribute('download','file.pdf') 
        link.click();
    }
      

    const getPromiseDoc = ()=>{
        setpromiseLoading(true)
        const token = getLocal(appIdentifier)?.jwt ; 
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
        "data": {
            "thesis_id": selectedInfo?.id
        }
        });

        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
        };

fetch(`${globalUrlBare}/api/teachers/get_promise_doc`, requestOptions)
  .then(response => response.json())
  .then(result => {
    setpromiseLoading(false)
        if(result){
            // window.location.assign()
            downloadFile(result?.url)
            // window.open(result?.url, 'Download');
        }
    }
    )
  .catch(error => {
    setpromiseLoading(false)
    console.log('error', error)
    });
    }


    const getRateDoc = ()=>{
        setrateLoading(true)
        const token = getLocal(appIdentifier)?.jwt ; 
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
        "data": {
            "thesis_id": selectedInfo?.id
        }
        });

        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
        };

fetch(`${globalUrlBare}/api/teachers/get_rate_doc`, requestOptions)
  .then(response => response.json())
  .then(result => {
    setrateLoading(false)
        if(result){
            // window.location.assign()
            downloadFile(result?.url)
            // window.open(result?.url, 'Download');
        }
    }
    )
  .catch(error => {
    setrateLoading(false)
    console.log('error', error)
    });
    }

    const UpdateDissertationObject = (data)=>{
        editDataWithToken(`dissertations/${selectedInfo?.id}`,data,(err, result)=>{
            const {error} = result
            if(err){
                message?.error('خطأ في الشبكة')
            }else{
                if(!error){
                    message?.success('تم تعديل البيانات بنجاح');
                    getThesis();
                }else{
                    console.log(error)
                    message?.error(error?.message)
                }
            
            }
        })
    }

    const uploadPromiseFile = (fileId)=>{

        const uploadPromiseFileContent = (fileId)=>{
            const data = {stamped_promise_attachement:fileId}
            UpdateDissertationObject(data)
        }

        uploadFileWithResult(promiseFiles[0],(res)=>uploadPromiseFileContent(res?.[0]?.id))
        
    }

    const uploadRateFile = (fileId)=>{

        const uploadRateFileContent = (fileId)=>{
            const data = {stamped_rate_attachement:fileId}
            UpdateDissertationObject(data)
        }

        uploadFileWithResult(rateFiles[0],(res)=>uploadRateFileContent(res?.[0]?.id))
        
    }

    const finalSubmit = (data)=>{
       
        const {decision_status,decision_details } = data
       
      
        if(addInfoForm?.getFieldValue('decision_status')==null||(addInfoForm?.getFieldValue('decision_status')!=null&&addInfoForm?.getFieldValue('decision_status')!='accepted_no_notes'&&addInfoForm?.getFieldValue('decision_details')==null)||selectedInfo?.stamped_rate_attachement?.length==0||selectedInfo?.stamped_promise_attachement?.length==0){
            message?.success('يرجى ملئ كافة معلومات ');
        }else{
            confirm({
                title: `  هل انت متآكد انك تود الارسال النهائي `,
                icon: <ExclamationCircleOutlined style={{color:'#FFC108'}} />,
                content: 'ملاحظة : البيانات المرسلة لا يمكن تعديلها لاحقا',
                okText: 'نعم',
                okType: 'primary',
                cancelText: 'الغاء',
                width:480,
                style:{textAlign:'right'},
                onOk() {
                    const newData = {...data, submitted:true}
                    UpdateDissertationObject(newData)
                    onAddClose();
                },
                onCancel() {
                    console.log('Cancel');
                },
                });
          
        }
       
    }

    
    
    return(
        <Layout className='mainContainer'>

            <Drawer
                title={` تفاصيل الاطروحة / الرسالة  ( ${selectedInfo?.title} ) \xa0\xa0\xa0\xa0\xa0 \xa0\xa0\xa0\xa0\xa0 الطالب (${selectedInfo?.student_name}) `}
                placement="left"
                closable={false}
                onClose={onAddClose}
                visible={addInfoVisible}
                width={window.innerWidth > 900 ? 700 :  350}
            >

                

                <Divider orientation="right" orientationMargin="0" >الملفات المرسلة للمقوم العلمي</Divider>
                <Row style={{padding:24, paddingTop:16, backgroundColor:'#f9f9f9'}}>
                    {
                        selectedInfo?.sender_attachment?.map((item, index) => {
                            return(
                                <Button target={'_blank'}  style={{marginLeft:16, marginBottom:16}} href={`${globalUrlBare}${item?.url}`} type="primary" shape="round" icon={<DownloadOutlined />} size={'middle'}>
                                    تنزيل المرفق  {`\xa0\xa0\xa0\xa0\xa0 ${index+1}`}
                                </Button>
                            )
                            
                        })
                    }

                </Row>

                <Form 
                    form={addInfoForm} 
                    onFinish={finalSubmit}
                    scrollToFirstError={true}
                    onValuesChange={(changedValues,allValues)=>{
                        setInfoFormInfo(allValues);
                    }}
                    layout='inline'
                >

                    <Divider orientation="right" orientationMargin="0" >تفاصيل التقييم</Divider>
                
                    <Row style={{padding:24, paddingTop:16, backgroundColor:'#f9f9f9',width:'100%'}}>

                            
                                <Form.Item    
                                    className='myFormItem'
                                    name="decision_status" 
                                    rules={[{ required: true, message: 'يرجى اختيار حالة التقييم' }]}
                                    label="حالة التقييم"
                                >
                                    <Select size="large"  placeholder="حالة التقييم" style={{minWidth:350}}>
                                        {
                                            [
                                                {title:'صالح للمناقشة بدون ملاحظات', value:'accepted_no_notes'},
                                                {title:'صالح للمناقشة - مع عرض الملاحظات المرفقة على لجنة المناقشة (حصراً)', value:'accepted_with_notes'},
                                                {title:'لا تصلح للمناقشة - مع ذكر الاسباب المبررة الموجبة لرفض الرسالة / الاطروحة', value:'rejected'}
                                            ]?.map(({value,title},index) => {
                                                return(<Option value={value} key={value} >{title}</Option>)
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                                {
                                    addInfoForm?.getFieldValue('decision_status')!=null&&addInfoForm?.getFieldValue('decision_status')!='accepted_no_notes'&&
                                    <Form.Item    
                                        className='myFormItem'
                                        name="decision_details" 
                                        rules={[{ required: true  ,
                                        message: 'ملاحظات التقييم' }]}
                                        label="ملاحظات التقييم"
                                    >
                                    
                                    <Input.TextArea showCount style={{minWidth:400}} />
                                    
                                </Form.Item>
                                }
                                
                            

                    </Row>

                    <Divider orientation="right" orientationMargin="0" > استمارة تعهد السلامة الفكرية</Divider>
                
                    <Row style={{padding:24, paddingTop:16, backgroundColor:'#f9f9f9',width:'100%'}}>
                        
                        
                                <Button loading={promiseLoading} onClick={getPromiseDoc}  style={{marginLeft:16, marginBottom:16}}  type='link' shape="round" icon={<DownloadOutlined />} size={'middle'}>
                                    تنزيل  نموذج استمارة تعهد السلامة الفكرية لغرض التوقيع   
                                </Button>

                                {
                                    selectedInfo?.stamped_promise_attachement&&
                                    <Alert message="قمت مسبقاً برفع استمارة تعهد السلامة الفكرية الموقعة" type="info" showIcon />
                                    
                                }
                                {
                                    selectedInfo?.stamped_promise_attachement&&
                                    <Button icon={<EyeOutlined style={{fontSize:20}} />}  download={true}  href={`${globalUrlBare}${selectedInfo?.stamped_promise_attachement?.url}`}  style={{marginLeft:16, marginBottom:16, marginTop:20}}  type="link" type={'primary'}  size={'large'}>
                                        معاينة النسخة المرفوعة من استمارة تعهد السلامة الفكرية الموقعة
                                    </Button>
                                }



                                <Form.Item 
                                    name='stamped_promise_attachement' 
                                    label= {selectedInfo?.stamped_promise_attachement?"استبدال استمارة تعهد السلامة الفكرية الموقعة":"اختيار استمارة تعهد السلامة الفكرية الموقعة"  }
                                    className='myFormItem' 
                                    rules={[
                                       
                                    ]}
                                    >
                                        <input 
                                            title={selectedInfo?.stamped_promise_attachement?.length>0?'استبدال الملف':'رفع ملف'}
                                            type="file"
                                            onChange={(e)=>setpromiseFiles(e.target.files)}
                                            
                                        />

                                    
                                </Form.Item>
                               

                                <Button disabled={!promiseFiles} onClick={uploadPromiseFile}  style={{marginLeft:16, marginBottom:16}}  type="primary" shape="round" icon={<UploadOutlined style={{fontSize:20}} />} size={'middle'}>
                                    رفع استمارة تعهد السلامة الفكرية الموقعة 
                                </Button>

                            
                    </Row>

                    <Divider orientation="right" orientationMargin="0" > استمارة المقوم العلمي</Divider>
                
                    <Row style={{padding:24, paddingTop:16, backgroundColor:'#f9f9f9',width:'100%'}}>
                        
                        
                                <Button loading={rateLoading} onClick={getRateDoc}  style={{marginLeft:16, marginBottom:16}}  type='link' shape="round" icon={<DownloadOutlined />} size={'middle'}>
                                    تنزيل  نموذج استمارة المقوم العلمي لغرض التوقيع   
                                </Button>

                                {
                                    selectedInfo?.stamped_rate_attachement&&
                                    <Alert message="قمت مسبقاً برفع استمارة المقوم العلمي الموقعة" type="info" showIcon />
                                    
                                }
                                {
                                    selectedInfo?.stamped_rate_attachement&&
                                    <Button icon={<EyeOutlined style={{fontSize:20}} />}  download={true}  href={`${globalUrlBare}${selectedInfo?.stamped_rate_attachement?.url}`}  style={{marginLeft:16, marginBottom:16, marginTop:20}}  type="link" type={'primary'}  size={'large'}>
                                        معاينة النسخة المرفوعة من استمارة المقوم العلمي الموقعة
                                    </Button>
                                }

                                <Form.Item 
                                    name='stamped_rate_attachement' 
                                    label= {selectedInfo?.stamped_rate_attachement?"استبدال استمارة المقوم العلمي الموقعة":"اختيار استمارة المقوم العلمي الموقعة"  }
                                    className='myFormItem' 
                                    rules={[
                                        
                                    ]}
                                    >
                                        <input 
                                            title={selectedInfo?.stamped_rate_attachement?.length>0?'استبدال الملف':'رفع ملف'}
                                            type="file"
                                            onChange={(e)=>setrateFiles(e.target.files)}
                                            
                                        />

                                    
                                </Form.Item>

                                <Button onClick={uploadRateFile} disabled={!rateFiles} style={{marginLeft:16, marginBottom:16}}  type="primary" shape="round" icon={<UploadOutlined style={{fontSize:20}} />} size={'middle'}>
                                    رفع استمارة المقوم العلمي الموقعة 
                                </Button>

                            
                    </Row>

                    
                </Form>

                {/* <Divider orientation="right" orientationMargin="0" > مرفقات اضافية</Divider> */}
                
                {/* <Row style={{padding:24, paddingTop:16, backgroundColor:'#f9f9f9'}}>

                {
                                    selectedInfo?.teacher_attachment&&
                                    <Button icon={<EyeOutlined style={{fontSize:20}} />}  download={true}  href={`${globalUrlBare}${selectedInfo?.stamped_rate_attachement?.url}`}  style={{marginLeft:16, marginBottom:16, marginTop:20}}  type="link" type={'primary'}  size={'large'}>
                                        معاينة المرفقات المرفوعة من قبل التدريسي
                                    </Button>
                                }

                                <Form.Item 
                                    name='teacher_attachment' 
                                    label= {selectedInfo?.stamped_rate_attachement?"استبدال استمارة المقوم العلمي الموقعة":"اختيار استمارة المقوم العلمي الموقعة"  }
                                    className='myFormItem' 
                                    rules={[
                                        {
                                        required: true,
                                        message: 'يرجى اختيار استمارة المقوم العلمي الموقعة"',
                                        }
                                    ]}
                                    >
                                        <input 
                                            title={selectedInfo?.stamped_rate_attachement?.length>0?'استبدال الملف':'رفع ملف'}
                                            type="file"
                                            onChange={(e)=>setrateFiles(e.target.files)}
                                            
                                        />

                                    
                                </Form.Item>

                                <Button onClick={uploadRateFile} disabled={!rateFiles} style={{marginLeft:16, marginBottom:16}}  type="primary" shape="round" icon={<UploadOutlined style={{fontSize:20}} />} size={'middle'}>
                                    رفع استمارة المقوم العلمي الموقعة 
                                </Button>
                    
                        
                </Row> */}

                <Divider orientation="right" orientationMargin="0" > الارسال النهائي</Divider>

                <Row style={{padding:24, paddingTop:16, height:50}}>
                    <Button onClick={()=>addInfoForm.submit()} disabled={addInfoForm?.getFieldValue('decision_status')==null||selectedInfo?.stamped_rate_attachement?.length==0||selectedInfo?.stamped_promise_attachement?.length==0 } style={{marginLeft:16, marginBottom:16}}  type="primary"  icon={<SendOutlined style={{fontSize:20}} />} size={'middle'}>
                                    ارسال التقييم 
                    </Button>
                </Row>

                

                

               
              
                
            </Drawer>
        
            <GlobalHeader title={pageTitle}/>
            <Layout>
            
            <GlobalSider currentPage={'MngTeacherThesis'} currentSub={'sub1'} />
            <Layout
                style={{
                padding: '0 24px 24px',
                }}
            >
                <Breadcrumb
                style={{
                    margin: '16px 0',
                }}
                >
                <Breadcrumb.Item onClick={()=>navigate('/mnghome')}  style={{cursor: 'pointer'}} >الرئيسية</Breadcrumb.Item>
                <Breadcrumb.Item>{pageTitle}</Breadcrumb.Item>
                
                
                </Breadcrumb>
                <Content
                className="site-layout-background"
                style={{
                    padding: 24,
                    margin: 0,
                    minHeight: 280,
                }}
                >
                <Row  style={{padding:10}} >

                

                    <Col md={24} style={{marginTop:24}}>

                    <Table 
                        dataSource={infos}
                        pagination={{ position: ['bottomCenter'],total:totalCount}}
                        onChange={handleTableChange}
                        loading={addLoading}
                        scroll={{ x: '100%'}}
                        
                    >

                    

                        <Column title="اسم الطالب"  width="200px" key="student_name" fixed="left" dataIndex="student_name" />
                        <Column title="عنوان الرسالة \ الاطروحة"  width="200px" key="title"  dataIndex="title" />
                        

                        <Column title="الشهادة"  width="200px" key="certificate" 
                            render={(text, record) => (
                                <Space>
                                    {returnCertTitle(record?.student_certificate) }
                                </Space>
                                
                            )}
                        />
                        <Column title="الحالة"  width="400px" key="decision_status" 
                            render={(text, record) => (
                                <Space>
                                    {returnStatusTitle(record?.decision_status) }
                                </Space>
                                
                            )}
                        />


                        <Column title="الاختصاص العام للرسالة \ الاطروحة"  width="200px" key="dissertation_general_sepcialization" dataIndex="dissertation_general_sepcialization" />
                        <Column title="الاختصاص الدقيق للرسالة \ الاطروحة"  width="200px" key="dissertation_specific_sepcialization" dataIndex="dissertation_specific_sepcialization" />

                        

                        
                        <Column title="الجامعة"  width="200px" key="university" 
                            render={(text, record) => (
                                <Space>
                                    {record?.university?.title}
                                </Space>
                                
                            )}
                        />

                        <Column title="الكلية"  width="200px" key="college" 
                            render={(text, record) => (
                                <Space>
                                    {record?.college?.title}
                                </Space>
                                
                            )}
                        />
                        

        

                       
                       
                        <Column title="تاريخ اخر تعديل"  width="200px" key="updatedAt" 
                            render={(text, record) => (
                                <Space>
                                    { moment(record?.updatedAt).format(dateFormat) }
                                </Space>
                                
                            )}
                        />
                        <Column title="تم التعديل من قبل"  width="200px" key="updatedAt" 
                            render={(text, record) => (
                                <Space>
                                    { record?.sender?.fname||''}
                                </Space>
                                
                            )}
                        />

                        
                        {
                            localUserType==='teacher'&&
                            
                            <Column title="العمليات"  width="200px" key="status" 
                                fixed='right'
                                render={(text, record) => (
                                    <Space>
                                        {
                                            !record?.submitted?
                                            <Button onClick={()=> prepareGetDetails({id:record?.id,...record}) } style={{backgroundColor:Colors.primary, borderWidth:0}} type="primary" shape="round" icon={<FormOutlined />} size={20}>
                                                التقييم
                                            </Button>
                                            :
                                            <Tag color={'green'} >تم ارسال البحث </Tag>
                                        }
                                   

                                   
                                    </Space>
                                    
                                )}
                            />

                        }
                         
                
                    </Table>

                    </Col>
                   
                </Row>
                </Content>
            </Layout>
            </Layout>
        </Layout>
    )
}

export default MngTeacherThesis




